import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, InstagramIcon, TwitterIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/7XxvZjma91KZzYXXSDSoRf/Visiual_Eyes_logo.png';
export function Footer() {
  return <footer className="bg-brand-dark text-white pt-16 pb-8" data-id="element-196">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-197">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-198">
          {/* Brand Col */}
          <div data-id="element-199">
            <Link to="/" className="inline-block focus-ring rounded-sm w-fit mb-6" aria-label="VisualEyes Home" data-id="element-200">
              <img src={LOGO_URL} alt="VisualEyes - A member of Vision Source" className="h-[90px] w-auto brightness-0 invert" data-id="element-201" />
            </Link>
            <p className="text-gray-400 text-base leading-relaxed mb-6" data-id="element-202">
              We believe that all people should have access to first-class eye
              care. Our team works tirelessly to ensure that healthy eyes is a
              given for all people, all the time.
            </p>
            <div className="flex gap-4" data-id="element-203">
              <a href="https://www.instagram.com/visualeyesgroup/" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-gold transition-colors focus-ring" aria-label="Instagram" data-id="element-204">
                <InstagramIcon className="w-5 h-5" data-id="element-205" />
              </a>
              <a href="https://x.com/visualeyes4u" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-gold transition-colors focus-ring" aria-label="X" data-id="element-206">
                <TwitterIcon className="w-5 h-5" data-id="element-207" />
              </a>
              <a href="https://www.tiktok.com/@visualeyesgroup" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-gold transition-colors focus-ring" aria-label="TikTok" data-id="element-208">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-209">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.75a8.18 8.18 0 0 0 4.76 1.52V6.84a4.84 4.84 0 0 1-1-.15z" data-id="element-210" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-211">
            <h4 className="font-heading font-semibold text-lg mb-6 text-white" data-id="element-212">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-213">
              <li data-id="element-214">
                <Link to="/" className="text-gray-400 hover:text-brand-gold transition-colors focus-ring rounded-sm" data-id="element-215">
                  Home
                </Link>
              </li>
              <li data-id="element-216">
                <Link to="/team" className="text-gray-400 hover:text-brand-gold transition-colors focus-ring rounded-sm" data-id="element-217">
                  Team
                </Link>
              </li>
              <li data-id="element-218">
                <Link to="/services" className="text-gray-400 hover:text-brand-gold transition-colors focus-ring rounded-sm" data-id="element-219">
                  Services
                </Link>
              </li>
              <li data-id="element-220">
                <Link to="/locations" className="text-gray-400 hover:text-brand-gold transition-colors focus-ring rounded-sm" data-id="element-221">
                  Locations
                </Link>
              </li>
              <li data-id="element-222">
                <Link to="/about" className="text-gray-400 hover:text-brand-gold transition-colors focus-ring rounded-sm" data-id="element-223">
                  About Us
                </Link>
              </li>
              <li data-id="element-224">
                <Link to="/contact" className="text-gray-400 hover:text-brand-gold transition-colors focus-ring rounded-sm" data-id="element-225">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-226">
                <Link to="/payments" className="text-gray-400 hover:text-brand-gold transition-colors focus-ring rounded-sm" data-id="element-227">
                  Make a Payment
                </Link>
              </li>
              <li data-id="element-228">
                <Link to="/reviews" className="text-gray-400 hover:text-brand-gold transition-colors focus-ring rounded-sm" data-id="element-229">
                  Patient Reviews
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-230">
            <h4 className="font-heading font-semibold text-lg mb-6 text-white" data-id="element-231">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-232">
              <li className="flex gap-3 text-gray-400 text-sm" data-id="element-233">
                <MapPinIcon className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-234" />
                <span data-id="element-235">
                  10240 Lake Arbor Way
                  <br data-id="element-236" />
                  Mitchellville, MD 20721
                </span>
              </li>
              <li className="flex gap-3 text-gray-400 text-sm" data-id="element-237">
                <PhoneIcon className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-238" />
                <a href="tel:3013249500" className="hover:text-brand-gold transition-colors" data-id="element-239">
                  (301) 324-9500
                </a>
              </li>
              <li className="flex gap-3 text-gray-400 text-sm" data-id="element-240">
                <MailIcon className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-241" />
                <a href="mailto:info@visualeyesgroup.com" className="hover:text-brand-gold transition-colors" data-id="element-242">
                  info@visualeyesgroup.com
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-243">
            <h4 className="font-heading font-semibold text-lg mb-6 text-white" data-id="element-244">
              Newsletter
            </h4>
            <p className="text-gray-400 text-sm mb-4" data-id="element-245">
              Subscribe to get eye health tips and clinic updates.
            </p>
            <form className="flex flex-col gap-3" onSubmit={e => e.preventDefault()} data-id="element-246">
              <input type="email" placeholder="Your email address" className="bg-white/10 border border-white/20 rounded-button px-4 py-2.5 text-white placeholder:text-gray-500 focus-ring" required aria-label="Email for newsletter" data-id="element-247" />
              <button type="submit" className="bg-brand-gold hover:bg-brand-gold-light text-white font-semibold py-2.5 rounded-button transition-colors focus-ring" data-id="element-248">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-249">
          <p className="text-gray-500 text-base text-center md:text-left" data-id="element-250">
            © 2026 Visual Eyes Group. All rights reserved.
          </p>
          <div className="flex gap-6 text-base text-gray-500" data-id="element-251">
            <a href="#" className="hover:text-white transition-colors focus-ring rounded-sm" data-id="element-252">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors focus-ring rounded-sm" data-id="element-253">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}